export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const COVERS = {
  ebook_vital_blueprint:
    "https://static.prod-images.emergentagent.com/jobs/19f0e89e-3e84-4615-ae21-d859999bcda3/images/dcb9ad5d129941d5ccd41e7d75fd5797463b1de7793bc7b0ddce03685d336887.jpeg",
  ebook_wealth_reset:
    "https://static.prod-images.emergentagent.com/jobs/19f0e89e-3e84-4615-ae21-d859999bcda3/images/e290c0ee6e3c2f75f07b66c43862dd73f2d3948fd5e1ae924174c8abe4415b10.jpeg",
  ebook_resilient_mind:
    "https://static.prod-images.emergentagent.com/jobs/19f0e89e-3e84-4615-ae21-d859999bcda3/images/dcf19fca03f4d6ff60cdfac69a242aea65d36053c078462950f17eb2da4eddac.jpeg",
};

export const IMAGES = {
  portrait:
    "https://static.prod-images.emergentagent.com/jobs/19f0e89e-3e84-4615-ae21-d859999bcda3/images/df74cf2b2849b0686e962d9fcbfcb06b81e4b984fbc7b44cb83f9accc0b5e562.jpeg",
  office:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_landing-page-guide-46/artifacts/736ymf54_Dr.%20Tony%20Ogundipe.jpg",
  texture:
    "https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  wellness:
    "https://images.unsplash.com/photo-1506126613408-eca07ce68773?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
